class CollectionFilter extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      item: '.collection-filter__item',
      products: '#collection-grid-wrapper'
    }

    this.setupEventListeners()
  }

  setupEventListeners () {
    this.addEventListener('click', (event) => {
      if (event.target.closest(this.selectors.item)) {
        event.preventDefault()

        const url = event.target.href

        if (url && url !== '#' && location.href !== url) {
          history.pushState(null, null, url)

          Array.from(this.querySelectorAll(this.selectors.item))
            .forEach(item => item.classList.remove('active'))

          event.target.classList.add('active')

          fetch(`${url}?sections=main-collection-product-grid`)
            .then(response => response.json())
            .then(data => {
              const products = document.querySelector(this.selectors.products)
              const parser = new DOMParser()
              const doc = parser.parseFromString(data['main-collection-product-grid'], 'text/html')

              if (products) {
                products.replaceWith(doc.querySelector(this.selectors.products))

                if (loadReviewsIoRatingSnippets) {
                  loadReviewsIoRatingSnippets()
                }
              }
            })
        }
      }
    })
  }
}

customElements.define('collection-filter', CollectionFilter)
